<template>
  <Popper hover :placement="placement">
    <slot></slot>
    <template #content>
      <div
        :class="[
          'mp-popover align-center justify-center',
          {
            'flex-column-reverse': placement == 'top',
            'flex-column': placement == 'bottom',
            'flex-row-reverse': placement == 'left',
            'flex-row reverse': placement == 'right',
          },
        ]"
      >
        <img
          draggable="false"
          class="arrow"
          src="~@/assets/images/home_pic10_pop@2x.png"
        />
        <div class="card-block">
          <img
            draggable="false"
            class="qrcode"
            src="~@/assets/images/mp_qrcode.jpg"
          />
        </div>
      </div>
    </template>
  </Popper>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    placement: {
      type: String,
      default: 'bottom',
    },
  }
});
</script>

<style lang="less" scope>
.popper[data-popper-placement^="top"] .arrow {
  transform: translateY(-0.4px) rotate(180deg);
}

.popper[data-popper-placement^="left"] .arrow {
  transform: rotate(90deg) translateY(0.36vw);
}

.popper[data-popper-placement^="right"] .arrow {
  transform: rotate(270deg) translateY(0.36vw);
}

.mp-popover {
  .arrow {
    width: 1.06vw;
    height: 0.36vw;
    z-index: 1;
  }
  .card-block {
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    padding: 0.57vw;
    border-radius: 1vw;
  }
  .qrcode {
    width: 150px;
    height: auto;
    border-radius: 50%;
    padding: 0.31vw;
    background: white;
  }
}
</style>